import { useEffect, useState } from "react";
import { Loader2, Search } from "lucide-react";
import { searchProducts } from "@/lib/bf";

export default function BFProductSearch({ onAdd }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return undefined; }
    setBusy(true);
    const t = setTimeout(() => searchProducts(q).then((l) => setRows(l.filter((o, i) => l.findIndex((x) => x.name === o.name && x.code === o.code) === i))).catch(() => setRows([])).finally(() => setBusy(false)), 280);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div className="bf-lp" data-testid="bf-ao-search">
      <label className="bf-stock-search">{busy ? <Loader2 size={15} className="animate-spin" /> : <Search size={15} />}
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Adaugă produs: cod, denumire sau nuanță (ex. 7.32, A03505, blondie black)" data-testid="bf-ao-search-input" /></label>
      {rows.length > 0 && (
        <ul>{rows.map((o) => (
          <li key={o.key}><button type="button" onClick={() => { onAdd(o); setQ(""); }} data-testid={`bf-ao-opt-${o.key}`}><b>{o.name}</b> <small>cod {o.code}</small></button></li>
        ))}</ul>
      )}
      {q.trim().length >= 2 && !busy && !rows.length && <p className="st-hint">Niciun produs găsit.</p>}
    </div>
  );
}
